import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {catchError} from 'rxjs/internal/operators';
import {HttpClient} from '@angular/common/http';
import {ApiRoutes} from '../../../config/api-routes';
import {ApplicationStyleSettings} from '../model/ApplicationStyleSettings';

@Injectable()
export class ApplicationStyleService {

  constructor(private httpClient: HttpClient, private apiRoutes: ApiRoutes) { }

  public getApplicationStyleSettings(): Observable<ApplicationStyleSettings> {
    return this.httpClient.get<ApplicationStyleSettings>(this.apiRoutes.APPLICATION_STYLE)
      .pipe(
        catchError(error => {
          return of(null);
        })
      );
  }

  public updateBusinessStyleSettings(settings: ApplicationStyleSettings): Observable<ApplicationStyleSettings> {
  const settingsDTO = {...settings, value: JSON.stringify(settings.style)};
  delete settingsDTO.style;

    return this.httpClient.post<ApplicationStyleSettings>(this.apiRoutes.APPLICATION_STYLE, settings)
      .pipe(
        catchError(error => {
          return of(null);
        })
      );
  }

  public updateBusinessStyleLogo(logo: File): Observable<ApplicationStyleSettings> {
    const updateLogoForm = new FormData();
    updateLogoForm.append('logo', logo);
    return this.httpClient.post<ApplicationStyleSettings>(this.apiRoutes.BUSINESS_STYLE_LOGO, updateLogoForm);
  }

  public updateSignInBackground(background: File) {
    const updateSignInBackgroundForm = new FormData();
    updateSignInBackgroundForm.append('background', background);
    return this.httpClient.post<ApplicationStyleSettings>(this.apiRoutes.BUSINESS_SIGNIN_BACKGROUND, updateSignInBackgroundForm);
  }

  public removeBusinessStyleLogo() {
    return this.httpClient.delete<ApplicationStyleSettings>(this.apiRoutes.BUSINESS_STYLE_LOGO);
  }

  public removeBusinessStyleSignInBackground() {
    return this.httpClient.delete<ApplicationStyleSettings>(this.apiRoutes.BUSINESS_SIGNIN_BACKGROUND);
  }
}
